import axios from 'axios'
import router from '../router'
import TrainingVersion from '../../../Common/enums/TrainingVersion'

export default {
    namespaced: true,

    state: {
        isAuthenticated: false,
        appInitLoaded: false,
        accessToken: null,
        organisationId: null,
        roleType: null,
        chosenFacilityId: null,
        chosenFacilityName: null,
        hasChosenAFacility: false,
        authDetails: {},
        userDetails: {},
        userDetailsLoaded: false,
        claims: {},
        userAccount: null,
        trainingUpToDate: null,
        isNotificationManager: false
    },

    getters: {
        GetIsUserAuthenticated(state) {
            return state.isAuthenticated
        },

        GetAppInitLoaded(state) {
            return state.appInitLoaded
        },

        GetUserInitials(state) {
            return `${state.userDetails.firstName[0]}${state.userDetails.surname[0]}`
        },

        GetHasUserChosenAFacility(state) {
            return state.hasChosenAFacility
        },

        GetUserFacilityId(state) {
            return state.chosenFacilityId
        },

        GetUserAuthDetails(state) {
            return state.userAuthDetails
        },
        
        GetUserOrganisationId(state) {
            return state.organisationId
        },

        GetUserDetails(state) {
            return state.userDetails
        }, 

        GetUserDetailsLoaded(state) {
            return state.userDetailsLoaded
        },

        GetUserRoleType(state) {
            return state.roleType
        },

        GetUserPractitionerId(state) {
            return state.claims.extension_PractitionerId
        },

        GetUserFullName(state) {
            return `${state.userDetails.firstName} ${state.userDetails.surname}`
        },

        GetUserTitle(state) {
            return state.userDetails.title
        },

        GetUserAccount (state) {
            return state.userAccount
        },

        GetUserIsNotificationManager(state) {
            return state.isNotificationManager
        },

        GetTrainingUpToDate (state) {
            return state.trainingUpToDate
        }
    },

    mutations: {
        SET_USER_IS_AUTHENTICATED(state, data) {
            state.isAuthenticated = data
        },
        SET_ACCESS_TOKEN(state, data) {
            state.accessToken = data
        },
        PUSH_USER_DETAILS(state, data) {
            state.userDetails = data
            state.userDetailsLoaded = true,
            state.trainingUpToDate = data.trainingVersionCompleted >= TrainingVersion.CURRENT,
            state.isNotificationManager = data.isNotificationManager
        },
        SET_APP_INIT_LOADED(state) {
            state.appInitLoaded = true
        },
        SET_ORGANISATION_ID(state, data) {
            state.organisationId = data
        },
        SET_FACILITY(state, data) {
            state.hasChosenAFacility = true,
            state.chosenFacilityName = data.name,
            state.chosenFacilityId = data.id
        },
        SET_AUTH_DETAILS(state, data) {
            state.authDetails = data
        },
        SET_CLAIMS(state, data) {
            state.claims = data
        },
        SET_USER_NAME(state, data) {
            state.userDetails.firstName = data.firstName
            state.userDetails.surname = data.surname
        },
        SET_USER_ROLE_TYPE(state, data) {
            state.roleType = data
        },
        SET_TRAINING_UP_TO_DATE(state, data){
            state.trainingUpToDate = data
        },
        SIGNOUT(state) {
            state.isAuthenticated = false,
            state.accessToken = null,
            state.organisationId = null,
            state.roleType = null,
            state.chosenFacilityId = null,
            state.chosenFacilityName = null,
            state.hasChosenAFacility = false,
            state.authDetails = {},
            state.userDetails = {},
            state.userDetailsLoaded = false,
            state.userInitials = null,
            state.claims = []
        },
        SET_USER_ACCOUNT (state, data) {
            state.userAccount = data
        }
    },

    actions: {
        async GetPractitionerUserDetails({commit}, organisationId) {
            try {
                let response = await axios.get(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/practitioners/${organisationId}/me`) 
                commit('PUSH_USER_DETAILS', response.data)
                return response
            }
            catch(err) {
                throw new Error(err)
            }
        },

        async UpdatePractitionerUserDetails({commit}, data) {
            try {
                let response = await axios.patch(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/practitioners/${data.organisationId}/me`, data.userDetails)
                commit('PUSH_USER_DETAILS', response.data)
            }
            catch(err) {
                throw new Error(err)
            }
        },

        async UpdatePractitionerTrainingDetails({commit}, organisationId) {
            try {
                let response = await axios.patch(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/practitioners/complete-training/${organisationId}/me`, {
                    trainingVersion: TrainingVersion.CURRENT,
                    trainingCompletedDateTime: new Date().toISOString() //UTC
                })
            
                commit('PUSH_USER_DETAILS', response.data)
            }
            catch(err) {
                throw new Error(err)
            }
        },

        SetChosenFacility({commit}, data) {
            commit('SET_FACILITY', data)
        },
        
        SetUserName({commit}, data) {
            commit('SET_USER_NAME', data)
        },

        SetAppInitLoaded({commit}) {
            commit('SET_APP_INIT_LOADED')
        },

        SetTrainingUpToDate({commit}, data) {
            commit('SET_TRAINING_UP_TO_DATE', data)
        },

        async Signout({commit}) {
            commit('SIGNOUT')

            await router.app.$msal.signOut()
        }
    }
}